export default __webpack_public_path__ + "static/dudu-feature3-a49e661c1eb940c0ce089c257c67a160.png";